module.exports = __webpack_public_path__ + "img/html-evolution-4.70581874.jpg";